'use client';

import { useEffect } from 'react';
import { ErrorDisplay } from '@/components/error-display';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Root error boundary caught:', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <ErrorDisplay
        title="Something went wrong"
        message="We encountered an unexpected error. Don't worry, we're on it."
        error={error}
        onRetry={reset}
        showContactSupport={true}
      />
    </div>
  );
}